import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-CSRF-Token",
  withXSRFToken: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STATUS_STEPS = [
  { key: "idea", label: "Fikir" },
  { key: "scenario", label: "Senaryo" },
  { key: "approved", label: "Onay" },
  { key: "quoted", label: "Teklif" },
  { key: "paid", label: "Ödeme" },
  { key: "in_production", label: "Üretimde" },
  { key: "delivered", label: "Teslim" },
  { key: "completed", label: "Tamamlandı" },
];

export const STATUS_LABELS = STATUS_STEPS.reduce((a, s) => ({ ...a, [s.key]: s.label }), {});

export default api;
